import React from 'react'
import styles from './emailSenderModal.scss'
import CreatableSelect from 'react-select/lib/Creatable'
import ReactSelect2, {components as reactSelectComponents} from 'react-select'
import cs from 'classnames'
import i18n from 'lib/i18n'
import { remove } from 'lodash'

const _ = i18n('emailSender')

let selectInFocusWithin = false
/**
 * Customization object for the react-select using the same style like other components on tha site.
 */
export const customCreatableSelectStyles = {
    control: (base, state) => {
        selectInFocusWithin = state.isFocused
        return {
        ...base,
        flex: "4",
        fontSize: "12px",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "flex-end",
        color: "#000",
        backgroundColor: state.isDisabled ? "#f9f9f9" : "#fff",
        borderColor: "#d9d9d9 #ccc #b3b3b3",
        borderRadius: "2px",
        border: "1px solid #d9d9d9",
        minHeight: "25px",
        maxHeight: "auto",
        //height: state.isFocused ? "auto" : "25px",
        boxShadow: state.isFocused ? null : null,
        "&:hover": {
          borderColor: "#d9d9d9 #ccc #b3b3b3"
        },
        "&:focus": {
          borderColor: "#d9d9d9 #ccc #b3b3b3"
        },
        padding: 0,
        margin: 0,
        overflow: state.isFocused ? null : "hidden"
      }},
      menu: base => ({
        ...base,
        borderRadius: 2,
        hyphens: "auto",
        marginTop: 0,
        textAlign: "left",
        wordWrap: "break-word"
      }),
      menuList: base => ({
        ...base,
        padding: 0,
        verticalAlign: "baseline"
      }),
      singleValue: (base, state) => ({
        ...base,
        minHeight: "16px",
        lineHeight: "14px",
        color: "white",
      }),
      multiValue: (base, state) => ({
        ...base,
        minHeight: "16px",
        lineHeight: "14px",
        maxHeight: "18px",
        border: "0.5px solid #003366",
        background: '#003366',
        color: "white",
        div: {
            color: "white",
            fontSize: '1.2em',
            lineHeight: '0.8em'
        }
      }),
      /* noOptionsMessage: (base, state) => ({
        ...base,
        padding: 0,
        height: "20px",
        lineHeight: "16px"
      }), */
      option: (base, state) => ({
        ...base,
        padding: 0,
        fontSize: '1em',
        maxHeight: "25px"
      }),
      valueContainer: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        top: 0
      }),
      multiValueRemove: (base, state) =>{
        return state.data.isPermanentSelected ? {
        ...base,
        display: "none",
        padding: 0
      }: base
    },
      clearIndicator: (base, state) => ({
        ...base,
        padding: 0
      }),
      dropdownIndicator: (base, state) => ({
        ...base,
        marginTop: 0,
        padding: 0
      }),
      indicatorsContainer: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "23px",
        top: 0
      }),
      indicatorSeparator: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "0",
        top: 0
      }),
      group: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "20px",
        top: 0
      }),
      groupHeading: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "20px",
        top: 0
      }),
      input: (base, state) => ({
        ...base,
        padding: 0,
        margin: "2px 0 0 0",
        height: "20px",
        top: 0,
        fontSize: '1.2em',
        lineHeight: '0.8em',
        width: selectInFocusWithin ? '100%!important' : 'auto',
        div: {
            width: selectInFocusWithin ? '100%!important' : 'auto',
            input: {
                width: selectInFocusWithin ? '100%!important' : 'auto',
            },
        }
      }),
      noOptionsMessage: (base, state) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "20px",
        fontSize: '1em'
      }),
      placeholder: (base, state) => ({
        ...base,
        fontSize: '1.1em',
        lineHeight: '1.1em'
      })
}

/**
 * Custom dropdown indicator for react-select to be the similar style lik other elements on the page
 * @param {object} props
 */
export const DropdownIndicator = (props) => {
    return reactSelectComponents.DropdownIndicator && (
      <reactSelectComponents.DropdownIndicator {...props}>
        <span className={styles.downArrowHolder}>
                <span className={styles.downArrow}></span>
        </span>
      </reactSelectComponents.DropdownIndicator>
    )
}

/**
 * Custom dropdown indicator for react-select to be the similar style lik other elements on the page
 * @param {object} props
 */
export const NoOptionsMessage = (props) => {
    return reactSelectComponents.DropdownIndicator && (
      <reactSelectComponents.NoOptionsMessage {...props}>
        {_('noOptions')}
      </reactSelectComponents.NoOptionsMessage>
    )
}

const getDeleteIcon = () => {
    try {
        return require(`resources/images/a-trash_1x_ovbBlue.svg`)
    } catch(err) {
        return require(`resources/images/icn-no-result.svg`)
    }
}

/**
 *
 * @param {*} props
 */
const SelectRemovableOption = props => {
    return (
        <div className={styles.creatableOptionContainer} key={props.value+"_key"}>
        <reactSelectComponents.Option {...props} className={styles.creatableOptionItem}/>
            {props.data.isRecent &&
                <span>
                    <button type="button" className={styles.creatableOptionItem} onClick={event => {
                        event.preventDefault()
                        props.delete(props.value)
                    }}>
                        <img src={getDeleteIcon()}/>
                    </button>
                </span>
            }
        </div>
    )
}

/**
 * This is a custom MultiValueRemove for react select to be able set a separate unremovable value in dropdown
 * but the rest is still dynamic
 * @param {object} props
 */
const MultiValueRemove = props => {
    return (
        <reactSelectComponents.MultiValueRemove {...props}>
            {!props.data.isPermanentSelected ? props.children : null}
        </reactSelectComponents.MultiValueRemove>
    )
}

const MultiValueContainer = props => {
    return (
        <span className={styles.elementsInRow}>
            {props.data.firstCC ?
                <span className={styles.elementsInRow}>
                    <span className={styles.ccSpan}>CC: </span> <reactSelectComponents.MultiValueContainer {...props} />
                </span>
                :
                <reactSelectComponents.MultiValueContainer {...props} />
            }
        </span>
    )
}

const ValueContainer = ({ children, ...props }) => {

    // sort the recipients and mark the first CC to render a separator between recipients
    /* if (children && children[0] && children[0].length) {
        children[0].sort((a,b) => {
            return a.props.data.isCC > b.props.data.isCC ? 1 : -1
        })
        let firstCCIndex = -1
        children[0].forEach((item, index)=>{
            firstCCIndex === -1 && item.props.data.isCC ? (firstCCIndex = index) : null
        })
        if (firstCCIndex !== -1) {
            children[0][firstCCIndex].props.data.firstCC = true
        }
    } */
    let classNamesList = [styles.selectValueContainer]
    if (!props.selectProps.isMulti) {
        classNamesList.push(styles.selectValueContainerSingle)
    }

    return (<reactSelectComponents.ValueContainer {...props} className={cs(classNamesList)}>
        <div className={styles.composeRecipients}>
            {children}
        </div>
        <div className={styles.ccButtonHolder}>
            {props.selectProps.showCCButton ?
            <div className={styles.ccButtonInSelect} onClick={(e)=>{
                e.preventDefault()
                e.stopPropagation()
                props.selectProps.onClickCCButton(e)
            }}>
                CC
            </div>
            : null}
        </div>
    </reactSelectComponents.ValueContainer>)
}

/**
 * This component will render an email address composer element and provide a list of email addresses.
 * This input have a default email address list and the user can type new email addresses in to the list.
 * Te email addresses are separately removable.
 *
 * To validate the inserting value you can use this property for CreatableSelect
 * "isValidNewOption={(value)=>{
 *      return isAnEmail(value.trim())
 * }}"
 *
 */
export default class EmailAddressComposer extends React.Component {
	static propTypes = {
		emailToSelectField: React.PropTypes.object.isRequired,
		onChangeRecipientEmail: React.PropTypes.func.isRequired,
		templateContent: React.PropTypes.object.isRequired,
		emailToOptions: React.PropTypes.array.isRequired,
		allFieldDisabled: React.PropTypes.bool,
        isAnEmail: React.PropTypes.func.isRequired,
        isMulti: React.PropTypes.bool,
        isCreatable: React.PropTypes.bool,
        formatCreateLabel: React.PropTypes.string,
        customClassName: React.PropTypes.string,
        handleOnBlur: React.PropTypes.func,
        setDeleteItemByOption: React.PropTypes.func,
        showCCButton: React.PropTypes.bool,
        onClickCCButton: React.PropTypes.func,
    }

    constructor(props) {
		super(props)
    }

    handleBlur(value){

    }

    handleOnBlur(event){
        const {emailToSelectField, onChangeRecipientEmail, templateContent} = this.props
        let newValue = []

        if (emailToSelectField && emailToSelectField.value) {
            newValue = newValue.concat( emailToSelectField.value )
        }

        if (event && event.target && event.target.value) {
            newValue.push({label: event.target.value, value: event.target.value})
        }

        // add values to the list when blur, otherwise that will be lost
        onChangeRecipientEmail(newValue, templateContent)
        emailToSelectField.onChange(newValue)

        return emailToSelectField.onBlur(newValue)
    }

    /**
     * This function simplify to provide the correct Select component by args.
     * @param {*} isCreatable If true then Return a creatable select component else return a none creatable component.
     * @param {*} props the props to setup the component, like onclick, value, onBlur etc...
     * @returns The initialised component
     */
    getProperSelectModuleByCreatableArg(isCreatable, props) {
        if (isCreatable) {
            return <CreatableSelect {...props}/>
        }

        return <ReactSelect2 {...props}/>
    }

    render() {
        const {emailToSelectField, onChangeRecipientEmail, templateContent,
            emailToOptions, allFieldDisabled, isAnEmail, isMulti, formatCreateLabel,
            customClassName, handleOnBlur, showCCButton, onClickCCButton, setDeleteItemByOption, isCreatable} = this.props
        // placeholder={_('searchPromptText')}

        // prepare props for any kind of react select, must be do on this way, because there are more type of components,
        // what need the same setup to work
        const props = {
            openMenuOnFocus: true,
            placeholder:'',
            value: (()=>{
                if (!isMulti) {
                    return emailToSelectField.value && emailToSelectField.value[0] || null
                }

                return emailToSelectField.value
            })(),
            onChange: (value, {action, removedValue}) => {
                if (value && !Array.isArray(value)) {
                    value = [value]
                }

                if((action === 'remove-value' || action === 'pop-value') && removedValue.isPermanentSelected ){
                    return
                }

                if(action === 'clear'){
                    value = emailToSelectField.value.filter(v => v.isPermanentSelected)
                }

                onChangeRecipientEmail(value, templateContent)
                return emailToSelectField.onChange(value)
            },
            onBlur: (e)=> {
                if (handleOnBlur) {
                    handleOnBlur(e)
                } else {
                    this.handleOnBlur(e)
                }
            },
            onBlurResetsInput: false,
            options: emailToOptions,
            isDisabled: allFieldDisabled,
            isMulti: isMulti,
            isSearchable: true,
            formatCreateLabel: (value)=>`${formatCreateLabel} ${value}`,
            styles: customCreatableSelectStyles,
            components: { DropdownIndicator, NoOptionsMessage, Option: (p) => (SelectRemovableOption({...p, delete: setDeleteItemByOption})),
                MultiValueRemove,/* MultiValueContainer,*/ ValueContainer },
            className: customClassName,
            showCCButton: showCCButton && !allFieldDisabled,
            onClickCCButton: onClickCCButton
        }

        return this.getProperSelectModuleByCreatableArg(isCreatable, props)
    }
}



// WEBPACK FOOTER //
// ./components/emailSender/emailAddressComposer.jsx